import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { AvatarGroup } from './AvatarGroup';
import { AvatarGroupCounter } from './AvatarGroupCounter';
const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-20 h-20',
    xl: 'w-36 h-36',
};
const statusClasses = {
    offline: 'bg-gray-400',
    online: 'bg-green-400',
    away: 'bg-yellow-400',
    busy: 'bg-red-400',
};
const statusPositionClasses = {
    'top-left': '-top-1 -right-1',
    'top-right': '-top-1 -left-1',
    'bottom-left': '-bottom-1 -right-1',
    'bottom-right': '-bottom-1 -left-1',
};
const AvatarComponent = ({ img, status, children, statusPosition = 'top-right', size = 'md', rounded = false, bordered = false, stacked = false, }) => {
    return (_jsxs("div", { className: "flex items-center space-x-4", children: [_jsxs("div", { className: "relative", children: [img ? (_jsx("img", { className: classNames(sizeClasses[size], {
                            rounded: !rounded,
                            'rounded-full': rounded,
                            'ring-2 ring-gray-300 dark:ring-gray-500': bordered || stacked,
                            'p-1': bordered,
                        }), src: img, alt: "Rounded avatar" })) : (_jsx("div", { className: classNames(`relative overflow-hidden bg-gray-100 dark:bg-gray-600`, sizeClasses[size], {
                            rounded: !rounded,
                            'rounded-full': rounded,
                            'ring-2 ring-gray-300 dark:ring-gray-500': bordered || stacked,
                            'p-1': bordered,
                        }), children: _jsx("svg", { className: "absolute -bottom-1 h-auto w-auto text-gray-400", fill: "currentColor", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { fillRule: "evenodd", d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z", clipRule: "evenodd" }) }) })), status && (_jsx("span", { className: classNames('absolute h-3.5 w-3.5 rounded-full border-2 border-white dark:border-gray-800', statusClasses[status], statusPositionClasses[statusPosition]) }))] }), children && _jsx("div", { children: children })] }));
};
export const Avatar = Object.assign(AvatarComponent, {
    Group: AvatarGroup,
    Counter: AvatarGroupCounter,
});
